import * as React from "react";

import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { useProvidedState } from "@shared-ui/provided-state-context";

import { WizardTabbed } from "components/shared/StorefrontWizard/WizardTabbed/WizardTabbed";
import { WizardHero } from "components/shared/StorefrontWizard/WizardHero/WizardHero";
import { ExtendedFTNode } from "src/typings/flexFramework/FlexComponent";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";
import { UitkSpacingProps, UitkSpacing } from "uitk-react-spacing";

export const StorefrontWizardRegionBEXViewV2 = (props: {
  heroImageSrc: string;
  heroImageColor: string;
  heroImageFigureClassNames?: string;
  context: any;
  trackOnChangeTab: (tab: string) => void;
  wizardFormChildren: React.ReactElement[];
  wizardLOBs: ExtendedFTNode[];
  wizardState: ClientWizardStateStore;
  aboveOtherFormChildren: React.ReactElement[];
  belowOtherFormChildren: React.ReactElement[];
}) => {
  const {
    wizardLOBs,
    context,
    wizardFormChildren,
    trackOnChangeTab,
    belowOtherFormChildren,
    aboveOtherFormChildren,
    heroImageFigureClassNames,
  } = props;
  const [data] = useProvidedState();
  const isTripsHeroActive = data?.tripsHero?.isRendered ?? false;
  const className = !isTripsHeroActive ? "StorefrontWizardRegionBEX" : "StorefrontWizardRegionBEXTripsHero";

  const regionSpacing: UitkSpacingProps = { padding: { blockend: "unset" }, margin: { blockend: "unset" } };

  return (
    <UitkSpacing {...regionSpacing}>
      <div className={`${className}`} data-testid="storefront-region">
        <div id="wizardMainRegionV2" data-testid="main-region">
          <Viewport>
            <ViewSmall>
              <WizardTabbed
                wizardLOBs={wizardLOBs}
                context={context}
                wizardFormChildren={wizardFormChildren}
                trackOnChangeTab={trackOnChangeTab}
                belowOtherFormChildren={belowOtherFormChildren}
                aboveOtherFormChildren={aboveOtherFormChildren}
              />
            </ViewSmall>
            <ViewMedium>
              <WizardHero
                heroImageFigureClassNames={`bexHeroImageFigure bexHeroImageFigureV2 ${heroImageFigureClassNames ?? ""}`}
                {...props}
              />
            </ViewMedium>
          </Viewport>
        </div>
      </div>
    </UitkSpacing>
  );
};
